import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table, CommonErrors } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { eswiEnvs, eswiUtils } from "@/tra/tancis/eswi/comn";
import { HS_VRFN_PPUP } from "./HS_VRFN_PPUP";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_HS_APP,
    SG_APP_HS_CODE_LIST_R,
    SG_HS_APRV_HIST_LIST,
} from "@/tra/tancis/eswi/hs/vrfn/service/EswiHsVrfnService";

export const ESWI0101002S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    // const pgeUid = "UI-ESWO-0107-003S"; // Page Unique identifier !== 화면 고유 식별자 ==!
    const { pgeUid, menuId } = usePage({
        auth: ["auth_eswi0007", "auth_eswi0008"],
    });
    const pgeTitle = "Registering Control HS Code"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { hsAppUuid } = useParams();

    const [hsAppDtlList, setHsAppDtlList] = useState(comnUtils.getGridData([]));

    const [hsAppAprvHistList, setHsAppAprvHistList] = useState(comnUtils.getGridData([]));

    const [prcssStatCd, setPrcssStatCd] = useState("");

    const refEditable = useRef(false);

    const refOfcrInfo = useRef<any>({});

    const tab = useTab({
        defaultSchema: {
            id: "tab",
            schema: [{ label: t("L_HS_CD") }, { label: t("T_APRV_HIST") }],
        },
    });

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "hsCd" },
            { area: "comnCd", comnCd: "ESW0031" },
            { area: "comnCd", comnCd: "ESW0032" },
            { area: "comnCd", comnCd: "ESW0030" },
            { area: "comnCd", comnCd: "ESW0029" },
            { area: "comnCd", comnCd: "ESW0009" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Registering HS Code Form !== HS 신청 Form==!
        hsAppForm: useForm({
            defaultSchema: SF_SCHEMA_HS_APP,
            defaultValues: {
                appDt: new Date(),
                prcssStatCd: "DR",
                orgChpnNm: auth.get("usrNm"),
                orgChpnId: auth.get("usrId"),
                orgNm: auth.get("coNm"),
                orgChpnTelno: auth.get("telNo"),
                orgChpnEml: auth.get("emlAddr"),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Registering HS Code List !== Item Tab HS Code 등록 ==!
        appHsCodeList: useGrid({
            defaultSchema: SG_APP_HS_CODE_LIST_R,
            page: 0,
            size: 10,
        }),
        hsAppAprvHistList: useGrid({
            defaultSchema: SG_HS_APRV_HIST_LIST,
            page: 0,
            size: 10,
        }),
    };
    const render = {
        appHsCodeList: {
            head: {},
            cell: {},
            edit: {},
            row: (row: any, context: any) => {
                // row : 해당 row 의 데이터(rowValues)
                // return 값이 true 이면 row 보임
                // return 값이 false 이면 row 숨김
                // context 의 속성을 변경하여 row 의 바탕색 변경 가능
                if (row.prcsRoleTpCd === "SU" || row.prcsRoleTpCd === "AP") {
                    //context.backgroundColor = "blue"; // 3가지 색상 옵션 red , yellow , blue
                }
                return true;
            },
            checkbox: (row: any) => {
                // row : 해당 row 의 데이터(rowValues)
                return !(row.deletableYn === "N");
            },
        },
        hsAppAprvHistList: {},
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getHsAppInfo: useFetch({
            api: (hsAppUuid) => {
                return APIS.getHsAppInfo(hsAppUuid);
            },
            onSuccess: (data) => {
                console.log("getAppDtl onSuccess ==================== ", data);
                if (!data.appInfo.content.info || !data.appInfo.content.info?.hsAppUuid) {
                    // no data
                    modal.openModal({
                        content: "msg.com.00034",
                        onCancel: () => {
                            navigate(URLS.eswi0101001q);
                        },
                    });
                } else {
                    form.hsAppForm.setValues(data.appInfo.content.info);

                    refOfcrInfo.current = data.appInfo.content.ofcrInfo;
                    const asinOfcrId = refOfcrInfo.current.asinOfcrId;
                    const prcssStatCd = form.hsAppForm.getValue("prcssStatCd");

                    console.log(" asinOfcrId ", asinOfcrId);

                    refEditable.current =
                        asinOfcrId &&
                        (asinOfcrId == auth.get("usrId") || asinOfcrId == auth.get("asisSysmUsrId")) &&
                        (prcssStatCd == "RC" || prcssStatCd == "VE");

                    setPrcssStatCd(prcssStatCd);
                    setHsAppDtlList(comnUtils.getGridData(data.appInfo?.content?.list || []));
                }
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.com.00025" });
            },
            showToast: false,
        }),
        getHsAppAprvHistList: useFetch({
            api: (hsAppUuid) => {
                return APIS.getHsAppAprvHistList(hsAppUuid);
            },
            onSuccess: (data) => {
                console.log("getAppDtl onSuccess ==================== ", data);
                setHsAppAprvHistList(comnUtils.getGridData(data.result?.content || []));
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.com.00025" });
            },
            showToast: false,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Delete Item list deletion event !== 품목 목록 삭제 이벤트 ==!
        click_Btn_DeleteGridAppHsCodeList: () => {
            const seltList: any[] = grid.appHsCodeList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.00004" });
                return;
            }

            grid.appHsCodeList.deleteRow("checkbox");

            // modal.openModal({
            //     content: "msg.00103",
            //     onConfirm: () => {
            //         grid.appHsCodeList.deleteRow("checkbox");
            //     },
            // });
        },
        setInit: async () => {
            // ======== 임시 로직 ============ tin으로 기관 정보 조회해서 form에 orgCd, orgNm 값 세팅
            const info = await eswiUtils.setOrgInfoByTin(auth.get("tin"));
            form.hsAppForm.setValues({ ...eswiUtils.orgInfo });

            // HS App Information
            await fetch.getHsAppInfo.fetch(hsAppUuid);

            await fetch.getHsAppAprvHistList.fetch(hsAppUuid);
        },
    };

    // useEffect
    useEffect(() => {
        handler.setInit();
        form.hsAppForm.setEditable(false);
    }, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("L_APP_INFO")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgChpnNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgChpnTelno} />
                            <Group.Control {...form.hsAppForm.schema.orgChpnEml} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.hsAppNo} />
                            <Group.Control {...form.hsAppForm.schema.prcssStatCd} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="list"
                                onClick={() => {
                                    navigate(URLS.eswi0101001q);
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            {refEditable.current && (
                                <Button
                                    onClick={() => {
                                        console.log(" 심사 팝업");
                                        modal.openModal({
                                            content: <HS_VRFN_PPUP hsAppUuid={hsAppUuid} />,
                                            size: "md",
                                        });
                                    }}
                                >
                                    {t("L_APRV_RSLT")}
                                </Button>
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Tab {...tab.tab}>
                        <Tab.Panel>
                            <Group>
                                <Group.Body>
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("L_HS_CD_LST")} titleSize={1}></Group.Title>
                                        </Layout.Left>
                                        <Layout.Right></Layout.Right>
                                    </Layout>

                                    <Group.Section>
                                        <Grid
                                            {...grid.appHsCodeList.grid}
                                            data={hsAppDtlList}
                                            render={render.appHsCodeList}
                                        />
                                    </Group.Section>
                                </Group.Body>
                            </Group>
                        </Tab.Panel>
                        <Tab.Panel>
                            <Group>
                                <Group.Body>
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_APRV_HIST")} titleSize={1}></Group.Title>
                                        </Layout.Left>
                                        <Layout.Right></Layout.Right>
                                    </Layout>

                                    <Group.Section>
                                        <Grid
                                            {...grid.hsAppAprvHistList.grid}
                                            data={hsAppAprvHistList}
                                            render={render.hsAppAprvHistList}
                                        />
                                    </Group.Section>
                                </Group.Body>
                            </Group>
                        </Tab.Panel>
                    </Tab>
                </Group.Body>
            </Group>
        </Page>
    );
};
